// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'Local',
  appVersion: require('../../package.json').version,
  // IES
  // wsUrl: 'https://repse-desarrollo.rotoplas.com.mx/',
  // wsRepse: 'https://repse-desarrollo.rotoplas.com.mx/',
  // ROTOPLAS
  // wsUrl: 'https://repse-desarrollo.rotoplas.com.mx/',
  // wsRepse: 'https://repse-desarrollo.rotoplas.com.mx/',
  // production: false,
  // SYTESA
  wsUrl: 'https://repse.rotoplas.com.mx/',
  wsRepse: 'https://repse.rotoplas.com.mx/',
  production: false,

  expedienteEmpresa:1,
  expedientePeriodo:2,
  idCArpetaRepse: 2,
  idGPOProveedor: 110,
  idGPOAdministrador: 109,
  rotoplasSubsidiariaId: 203,
  rotoplasSubsidiariaNombre: 'ROTOPLAS S.A. DE C.V.',

  tipoExpedienteTrabajador: 3,
  cfdiTiposTrabajador: {
    pdf: [42],
    xml: [43]
  },
  rotoplasSubsidiarias: {
    ids: [226],
    keywords: ['ROTOPLAS'],
    rfcs: ['ROT7802026ZA']
  }


};

